export default "__VITE_ASSET__b458b2fe__"